import { gql, graphQueryBang } from "../../../shared/lib/graphql"
import { appletQueryFields as StaticAppletFragment } from "./reducers/applet"
import { serviceQueryFields as ServicesFragment } from "./reducers/services"

const PrivateServicesQuery = gql`
  query PrivateServicesQuery {
    me {
      private_channels {
        ${ServicesFragment}
      }
    }
  }
`

const StaticAppletAndTagsQuery = gql`
  query StaticAppletAndTagsQuery(
    $applet_id: String!
  ) {
    applet(id: $applet_id) {
      ${StaticAppletFragment}
    }
    tags { id name }
  }
`

const TagsQuery = gql`
  query TagsQuery {
    tags { id name }
  }
`

export function loadPrivateServices() {
  return graphQueryBang(PrivateServicesQuery).then(data => data.me.private_channels)
}

export function loadStaticApplet(appletId) {
  return graphQueryBang(StaticAppletAndTagsQuery, {
    applet_id: appletId,
  }).then(data => {
    return { applet: data.applet, tags: data.tags }
  })
}

export function loadTags() {
  return graphQueryBang(TagsQuery).then(data => ({ tags: data.tags }))
}
